import { render, staticRenderFns } from "./caption-loader.vue?vue&type=template&id=316ef34a&scoped=true&"
import script from "./caption-loader.vue?vue&type=script&lang=js&"
export * from "./caption-loader.vue?vue&type=script&lang=js&"
import style0 from "./caption-loader.vue?vue&type=style&index=0&id=316ef34a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ef34a",
  null
  
)

export default component.exports